import React  from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Rectangle,
  Label,
  
} from "recharts";
export default function Barchart() {
    
    const data = [
    {
        day: "Mon",
        Walking: 4000,
        Running: 2400,
        steps: 2400,
    },
    {
        day: "Tue",
        Walking: 3000,
        Running: 1398,
        steps: 2210,
    },
    {
        day: "Wed",
        Walking: 2000,
        Running: 9800,
        steps: 2290,
    },
    {
        day: "Thu",
        Walking: 2780,
        Running: 3908,
        steps: 2000,
    },
    {
        day: "Fri",
        Walking: 1890,
        Running: 4800,
        steps: 2181,
    },
    {
        day: "Sat",
        Walking: 2390,
        Running: 3800,
        steps: 2500,
    },
    {
        day: "Sun",
        Walking: 3490,
        Running: 4300,
        steps: 2100,
    },
    ];

      
    return (
    <>
            
        <BarChart className="barchart_outer"
        width={500}
        height={300}
        data={data}            
        >
        {/* <Legend /> */}
        <Legend layout="horizontal" verticalAlign="top" align="right" />
        <CartesianGrid strokeDasharray="0.1 0.1" />
        <XAxis dataKey="day"  axisLine={false} tickLine={false} />
        <YAxis axisLine={false} tickLine={false}/>
        
        <Bar className="barchart_inner"
        dataKey="Walking"
        fill="#005CFF"
        lineWidth="8"
        radius={[5, 5, 0, 0]}
        barSize={7}
        />

        <Bar className="barchart_inner"
        dataKey="Running"
        fill="#000"
        border-radius="8"
        lineWidth="8"
        radius={[5, 5, 0, 0]}
        barSize={7}
        />
    </BarChart>
      
</>
);
}

